import { CustomControlCode } from '@common/enums';
import { CustomControlRegistry } from '@frontend/components/pages/episodeCategory/customControls/customControlRegistry';
import { HolterDirectExaminationHolterConfigureButton } from './HolterDirectExaminationHolterConfigureButton';
import { holterDirectExaminationRequestInitialData } from './holterDirectExaminationRequestData';
import { HolterDirectExaminationRequestEdit } from './HolterDirectExaminationRequestEdit';
import { HolterDirectExaminationRequestRead } from './HolterDirectExaminationRequestRead';

CustomControlRegistry.instance.register({
    ButtonElement: HolterDirectExaminationHolterConfigureButton,
    EditElement: HolterDirectExaminationRequestEdit,
    ReadElement: HolterDirectExaminationRequestRead,
    code: CustomControlCode.HolterDirectExaminationRequest,
    initialData: holterDirectExaminationRequestInitialData,
    version: 1,
});
